// This file is AUTOGENERATED, do not edit it manually!!!

export const messageBoard = {
    AdditionalRecipients: 'Extra ontvangers',
    Ai_disabled_button: 'Begin te typen om AI-opdrachten te activeren',
    Append: 'Toevoegen',
    Apply: 'Toepassen',
    Approve: 'Goedkeuren',
    Approver_Approved: 'goedgekeurd',
    Approver_HasNotSeen: 'ongelezen',
    Approver_NoAction: 'geen actie',
    Approver_NotApproved: 'bekeken, goedkeuring in afwachting',
    Approver_Rejected: 'afgewezen',
    ApproversGroupTitle: 'Goedkeurders',
    Attachment_Delete: 'Bestand \'{0}\' is verwijderd.',
    BaseNotificationRule: 'Gebaseerd op meldingsregel',
    BeforePageUnloadMessage: 'Je wijzigingen gaan verloren. Wil je deze pagina verlaten zonder wijzigingen op te slaan?',
    Cancel: 'Annuleren',
    ChangeTone: 'Toon veranderen',
    Close: 'Sluiten',
    ContactAdministrator: 'Neem contact op met uw beheerder',
    ContinueWriting: 'Schrijf verder met AI',
    Delete: 'Verwijderen',
    DeleteAttachmentContentTemplate: 'Weet u zeker dat u de bijlage \'{0}\' wilt verwijderen?',
    DeleteAttachmentTitle: 'Bijlage verwijderen',
    Discard: 'Afbreken',
    Download: 'Downloaden',
    DropHere: 'Bestanden hier neerzetten',
    Edit: 'Bewerken',
    edit_actions: 'Druk op ctrl + enter om <a apply>Toepassen</a> of op esc om <a>Annuleren</a>',
    email_only_mention_title: 'Deze gebruiker wordt alleen per e-mail op de hoogte gesteld',
    Error: 'Fout',
    FilePlural: '1#{0} Bestand#{0} Bestanden',
    FileUploadError: 'Fout',
    FileVersion: 'Versie ',
    FileVersionShort: 'versie ',
    Formal: 'Formeel',
    FreeSpaceTemplate: 'U heeft {0} MB gebruikt van {1} MB.',
    Friendly: 'Vriendelijk',
    GeneratedByAi: 'Gegenereerd door AI...',
    HideFiles: 'Bestanden verbergen',
    ImproveSpelling: 'Spelling en grammatica verbeteren',
    ImproveWriting: 'Schrijven verbeteren',
    mention_title: 'Iemand vermelden',
    Message_Delete: 'Bericht is verwijderd.',
    message_maxLength_description: 'Een bericht mag maximaal 10.000 tekens bevatten.',
    message_maxLength_title: 'Het bericht is te lang',
    MessageDeleteConfirmation: 'Dit bericht verwijderen?',
    messageEdited: '(bewerkt)',
    MessageEditedBy: 'Bewerkt door ',
    messagePlaceholderText: 'Voeg een bericht toe, sleep bestanden of vermeld iemand met @',
    MultipleApproversTemplate: '{0} van de {1} {2}',
    MyComputer: 'Mijn computer',
    NewMessageWatermark: 'Typ een bericht of sleep bestanden...',
    NewPost: '1#{0} nieuw bericht #{0} nieuwe berichten',
    No: 'Nee',
    NoMatchRecipients: 'Lid is niet gevonden',
    NoPermissionToEditMessage: 'Sorry, u heeft geen toestemming om dit bericht te bewerken.',
    Notification: 'Melding',
    Notify: 'Melden',
    NotifyLabel: 'Melden...',
    NotProjectMembers: 'Niet-projectleden',
    OneDrive: 'OneDrive',
    OneDriveFilePicker: 'OneDrive-bestandskiezer',
    Optimistic: 'Optimistisch',
    Or: 'of',
    PluralApproved: '1#goedgekeurd#goedgekeurd',
    PluralRejected: '1#{0} afgewezen#{0} afgewezen',
    Post: 'Bericht',
    PostWatingForApproval: 'Bericht wacht op goedkeuring',
    PreviewImages: 'Afbeeldingen bekijken',
    Professional: 'Professioneel',
    ProjectMembers: 'Projectleden',
    Reject: 'Afwijzen',
    Replace: 'Vervangen',
    RequestApprovalLabel: 'Goedkeuring aanvragen',
    Retry: 'Opnieuw proberen',
    SharePoint: 'SharePoint',
    SharePointFilePicker: 'SharePoint-bestandskiezer',
    ShowFiles: 'Bestanden weergeven',
    ShowNext: 'Vorige weergeven',
    SingleApprovedTemplate: 'Goedgekeurd door {0}',
    SingleApprovedTemplate_You: 'Goedgekeurd door u.',
    SingleApproverTemplate: 'Wachten op goedkeuring van {0}',
    SingleRejectedTemplate: 'Afgewezen door {0}',
    SingleRejectedTemplate_You: 'Afgewezen door u.',
    Straightforward: 'Direct',
    Summarize: 'Samenvatten',
    SummarizeBulletPoints: 'Samenvatten in opsommingstekens',
    TabFiles: 'Bestanden',
    TabMessages: 'Berichten',
    Teams: 'Teams',
    Undo: 'Ongedaan maken',
    UploadedBy: 'door ',
    Yes: 'Ja',
    You: 'Jij',
};
